{
  "IMAGE_GENERATION": {
    "TITLE": "Generate Image",
    "ERROR_MESSAGE": "An error has occurred. Please try again.",
    "INSTRUCTIONS": "Enter a prompt to generate an image for your email"
  },
  "EMAIL_BUILDER": {
    "PROMPT_PLACEHOLDER": "Think about the objects, colors, and settings you want in your image and describe them in as much detail as possible. For example, \"a bright yellow sunflower in a field of green grass\" or \"a car with glasses on a sofa in Takishi Murakami style.\"",
    "GENERATE_CONTENT": "Generate image",
    "CANCEL": "Cancel",
    "USE_IMAGE": "Use image"
  }
}
